// extracted by mini-css-extract-plugin
module.exports = {"commonDialog":"index-module_commonDialog_3XwMK"};